import { Text, Card, CardHeader } from "@fluentui/react-components";
import { componentConstants } from "../../../utility/app-constants";

/**
 * To display the empty card when no to dos are present 
 * @returns 
 */
export default function TodosNoCard() {
    return (
        <Card
            className="todo-card-main"
            data-testid="to-dos-no-data-card"
        >
            <CardHeader
                className="todo-card-header-main"
                header={
                    <Text className="todo-no-card-header" weight="semibold">
                        {componentConstants.todosEmptyResponseCardData}
                    </Text>
                }
            />
        </Card>
    );
}
